<template>
  <div class="modal" :style="{ backgroundImage: `url(${image})` }" @click="closeModal">
    <div class="gradient"></div>
    <div class="content">
      <h2 class="bcLiguria" v-if="initials">{{ initials }}</h2>
      <h4 class="bcLiguria" :class="{'uppercase': !initials}">{{name}}</h4>
    </div>
    <p class="description">
      <!-- {{ description[$i18n.locale] }} -->
      {{description}}
    </p>
    <CloseIcon class="close-menu-icon"/>
  </div>
</template>

<script>
import CloseIcon from '@/assets/img/close-icon.svg'
export default {
  components: {
    CloseIcon
  },
  props: {
    name: String,
    description: String,
    image: String,
    initials: String
  },
  mounted () {
    this.setDynamicBackground()
  },
  methods: {
    setDynamicBackground () {
      const resolvedImage = require(`@/${this.image}`)
      this.$el.style.backgroundImage = `url('${resolvedImage}')`
    },
    closeModal () {
      const modal = document.querySelector('.modal')
      modal.classList.remove('fade-in')
      modal.classList.add('fade-out')
      setTimeout(() => {
        this.$emit('close-modal')
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
/* Variables */
$padding-base: 40px;
$font-size-base: 1rem;
$font-size-lg: 1.125rem;
$font-size-xl: 1.25rem;

/* Estilos globales */
.modal {
  position: fixed;
  inset: 0; /* top: 0; left: 0; right: 0; bottom: 0 */
  width: 100%;
  height: 100%;
  background-color: #1A1A1A;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  padding: $padding-base;

}

.gradient {
  position: absolute;
  inset: 0; /* top: 0; left: 0; right: 0; bottom: 0 */
  z-index: 0;
  background: linear-gradient(90deg, #000000e0 0, #0004);
}

.content {
  max-width: 150px;
  aspect-ratio: 1 / 1;
  background-color: black;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;

  @media (min-width: 640px) {
    max-width: 200px;
  }

  h2{
    font-size: 80px;
    color: #8C9091;
    margin-bottom: -8px;
  }
  h4 {
    font-size: 16px;
    color: #8C9091;
    &.uppercase {
      text-transform: uppercase;
    }
  }

  @media (min-width: 640px) {
    h2{
      font-size: 116px;
    }
    h4 {
      font-size: 18px;
    }
  }
}

.description {
  font-size: $font-size-lg;
  margin-top: $padding-base;
  color: #fff;
  z-index: 10;

  @media (min-width: 640px) {
    font-size: $font-size-xl;
    max-width: 33%;
  }
}

.close-menu-icon {
  position: absolute;
  top: $padding-base;
  right: $padding-base;
  width: $padding-base;
  height: $padding-base;
  cursor: pointer;
  fill: #fff;
}

/* Animaciones */
.fade-out {
  animation: fadeOut 0.5s forwards;
  opacity: 1;
}

@keyframes fadeOut {
  from {
    opacity: 1;
    scale: 1;
  }
  to {
    opacity: 0;
    scale: 0.8;
  }
}
</style>
